
  import { storeToRefs } from 'pinia';
  import { defineComponent, ref } from 'vue';
  import NewFilters from './NewFilters.vue';
  import NewTemplateList from './NewTemplateList.vue';
  import { PageTitle } from '@/ui/components/PageTitle';
  import TabletFrame from '@/_legacy/components/TabletFrame.vue';
  import ConductInspectionPreview from '@/_legacy/components/ConductInspection/ConductInspectionPreview.vue';
  import {
    Userflow,
    UserflowTrackEvent,
    UserflowTrackEventData,
  } from '@/services/userflow/userflow';
  import { pushRoute, toasted } from '@/ui/helpers';
  import { t } from '@/ui/i18n/i18n';
  import { CLICK_EVENTS, trackClick } from '@/services/activityTracker/activityTrackerHelper';
  import { goToCustomizeExistingTemplate } from '@/services/checklistTemplate/checklistBuiler';
  import { Button } from '@/ui/components/Button';
  import { useTemplateList } from '@/ui/concerns/checklist/useTemplateList';
  import LinkButton from '@/ui/components/checklist/LinkButton.vue';
  import { router } from '@/ui/routes';
  import { ConfirmationModal } from '@/ui/components/modals/ConfirmationModal';
  import { useChecklistSessionStorage } from '@/ui/concerns/useChecklistSessionStorage';
  import { useTemplate } from '@/ui/concerns/checklist/useTemplate';
  import { useTemplateLibraryStore } from '@/stores/checklist/templateLibrary';
  import { Icon } from '@/ui/components/icon/Icon';

  export default defineComponent({
    name: 'NewChecklistChooseTemplatePage',
    components: {
      ConfirmationModal,
      LinkButton,
      // @ts-ignore
      ConductInspectionPreview,
      TabletFrame,
      PageTitle,
      NewFilters,
      NewTemplateList,
      Button,
      Icon,
    },
    setup() {
      const { activeTemplate } = storeToRefs(useTemplateLibraryStore());

      const isMakingRequest = ref(true);
      const hideModal = () => {
        leaveModalShow.value = false;
      };
      const showModal = () => {
        leaveModalShow.value = true;
      };
      const leaveModalShow = ref(false);
      const { exitAction } = useChecklistSessionStorage();
      const {
        setActiveTemplate,
      } = useTemplateList();
      const {
        isLoading,
        newChecklistFromTemplate,
      } = useTemplate();

      const onGoBack = () => {
        router.push({ name: 'checklistChooseMethod' });
      };

      const onAddThisTemplateClick = async () => {
        if (!activeTemplate.value) {
          return;
        }

        trackClick({
          ...CLICK_EVENTS.CREATE_READY_MADE_TEMPLATE,
          'template-name': activeTemplate.value.title,
          'is-suggested': activeTemplate.value.isFeatured,
        });

        const mappedTemplate = {
          ...activeTemplate.value,
          fromTemplate: activeTemplate.value.id,
        };

        newChecklistFromTemplate(mappedTemplate, () => {
          Userflow.trackEvent(UserflowTrackEvent.TEMPLATE_CREATED, {
            [UserflowTrackEventData.TEMPLATE_NAME]: activeTemplate.value!.title,
          });
          toasted.success(t('checklist-templates.checklist-saved'));
          pushRoute({ name: 'forms' });
        });
      };

      const onCustomizeTemplateClick = () => {
        goToCustomizeExistingTemplate(activeTemplate.value!);
      };

      return {
        isLoading,
        isMakingRequest,
        activeTemplate,
        leaveModalShow,
        setActiveTemplate,
        onCustomizeTemplateClick,
        onAddThisTemplateClick,
        onGoBack,
        showModal,
        hideModal,
        exitAction,
      };
    },
  });
